function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;

  return (
    <div className="my_flex_right">
      <label>
        <input type="checkbox" value="" className="search-input"
          checked={listOpt.s_in_now_period === "1" ? true : false}
          name="s_in_now_period"
          onChange={(e: any) => {
            let change_list_opt = { ...listOpt };
            if (e.target.checked) {
              change_list_opt.s_in_now_period = "1";
            } else {
              change_list_opt.s_in_now_period = "";
            }
            myProps.list(change_list_opt);
          }} />
        <span className="ml-1">사용중인교재</span>
      </label>
      <button className="btn btn-dark" onClick={() => { myProps.list({}); }}>검색</button>
    </div>
  );
};
export default SearchArea;